//====================================================
//  Function: Reposition Products
//====================================================

function componentsRepositionProducts() {
  if ($(".products-block").length) {
    partsRepositionProducts();
  }
}

function partsRepositionProducts() {
  if ($(".products-block").length) {
    var product,
      productAvailability,
      productPriceStandard,
      productPIn,
      productSave,
      productFlagsDefault;

    $(".products-block .product").each(function () {
      product = $(this);
      productAvailability = product.find(".availability");
      productImage = product.find(".image");
      productPIn = product.find(".p-in");
      productPBottom = product.find(".p-bottom");
      productPriceStandard = product.find(".price-standard");
      productSave = product.find(".price-save").text();

      if (product.find(".flags-default").length == 0) {
        productImage.prepend('<div class="flags flags-default"></div>');
      }

      if (product.find(".flag-viac_farieb").length > 0) {
        productPIn.append(product.find(".flag-viac_farieb"));
      }

      if (
        product.find(".flag-discount").length > 0 &&
        product.find(".flags-default .flag-discount").length == 0
      ) {
        productFlagsDefault = product.find(".flags-default");
        productFlagsDefault.append(
          '<div class="flag flag-discount"><div class="price-save">' +
            productSave +
            "</div></div>"
        );
      }

      product.find(".p-tools").append(productAvailability);
      product.find(".price-final").append(productPriceStandard);
    });
  }
}

function addMOCLabelProduct() {
  var labelText, prefixText;
  
  switch(lang) {
    case 'sk':
      labelText = "MOC";
      prefixText = "od ";
      break;
    case 'hu':
      labelText = "kisker ár";
      prefixText = "-tól";
      break;
    case 'cs':
      labelText = "MOC";
      prefixText = "od ";
      break;
    case 'ro':
      labelText = "PRP";
      prefixText = "de la ";
      break;
    default:
      return;
  }
  
  $(".p[data-micro='product']").each(function () {
    var $product = $(this);
    if ($product.find(".moc-label").length > 0) return;
    
    var $mocPriceElement = $product.find(".w-moc-price");
    if ($mocPriceElement.length === 0 || $mocPriceElement.find("span").length === 0) return;
    
    var $priceSpans = $mocPriceElement.find("span");
    var mocPrice;
    
    if ($priceSpans.length > 1) {
      var lowestNum = null;
      var lowestText = "";
      $priceSpans.each(function() {
        var priceText = $(this).text().trim();
        var num = parseFloat(priceText.replace(/[^\d\.]/g, ''));
        if (!isNaN(num) && (lowestNum === null || num < lowestNum)) {
          lowestNum = num;
          lowestText = priceText;
        }
      });
      // for HU add the prefix after the price
      if (lang === 'hu') {
        mocPrice = lowestText + prefixText;
      } else {
        mocPrice = prefixText + lowestText;
      }
    } else {
      mocPrice = $priceSpans.first().text().trim();
    }
    
    if (!mocPrice) return;
    
    var $pricesContainer = $product.find(".prices");
    if ($pricesContainer.length > 0) {
      $pricesContainer.find(".moc-label").remove();
      var $mocWrapper = $("<div class='moc-label'></div>");
      var $labelSpan = $("<span class='moc-label-text'>" + labelText + " </span>");
      var $priceSpan = $("<span class='moc-price'>" + mocPrice + "</span>");
      
      $mocWrapper.append($labelSpan).append($priceSpan);
      $pricesContainer.prepend($mocWrapper);
    }
  });
}

function initYotpoCategoryStars() {
  const shopInstanceIds = {
    wsk: '1121293',
    whu: '1129502',
    wcz: '1129500',
    wro: '1129504',
    jam: '1129515',
    mee: '1129548',
  };

  const instanceId = shopInstanceIds[shopName];
  if (!instanceId) return;

  $('.product').each(function () {
    const $product = $(this);
    const sku = $product.find('span[data-micro="sku"]').text().trim().replace(/\//g, '_');
    const $tools = $product.find('.p-tools');
    if (!sku || !$tools.length) return;

    const existingWidget = $tools.find(`.yotpo-widget-instance[data-yotpo-product-id="${sku}"]`);
    if (existingWidget.length) return;

    const $widget = $(`<div class="yotpo-widget-instance" style="display: none;" data-yotpo-instance-id="${instanceId}" data-yotpo-product-id="${sku}"></div>`);
    $tools.append($widget);

    let tries = 0;
    const maxTries = 30;

    const interval = setInterval(() => {
      const $textEl = $widget.find('.yotpo-sr-bottom-line-text');
      const text = $textEl.text().trim();
      const count = parseInt(text.replace(/[^\d]/g, ''), 10);

      if (!isNaN(count)) {
        if (count > 0) {
          $widget.css('display', 'flex'); 
        } else {
          $widget.hide();
        }
        clearInterval(interval);
      }

      if (++tries >= maxTries) clearInterval(interval);
    }, 400);
  });
}
